__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mfe-bridge";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ionic/react", "6.7.5", () => (() => (__webpack_require__(4672))), 1);
			register("@module-federation/utilities", "3.1.72", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(3599))))));
			register("@reduxjs/toolkit", "1.9.7", () => (() => (__webpack_require__(8716))), 1);
			register("@sequelae/lore-mfe-kit", "1.0.9", () => (() => (__webpack_require__(5949))), 1);
			register("history", "4.10.1", () => (() => (__webpack_require__(7321))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(7950))), 1);
			register("react-is", "16.13.1", () => (() => (__webpack_require__(3763))), 1);
			register("react-is", "16.13.1", () => (() => (__webpack_require__(7681))), 1);
			register("react-is", "18.3.1", () => (() => (__webpack_require__(2706))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(2166))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(2582))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(1688))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(5043))), 1);
			register("web-vitals", "0.2.4", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(4422))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};